import { useContext, useState, useEffect, useReducer } from 'react'
import { Grid } from '@mui/material'
import HeroCarousel from './HeroCarousel.js'
import { listArticles } from '../data/index.js'
import { getSiteConfigRoutes } from '../../community/siteProvider'

export default function HomePageCarousel(props = {}) {
  const { cycleDurationMs } = props
  const [allArticles, setAllArtices] = useState([])

  const initialState = {
    // '{sitedId}': {
    //   loading: false,
    //   loadingMore: false,
    //   articles: [],
    //   totalAvailable: undefined,
    //   totalLoaded: 0,
    //   nextToken: undefined,
    // }
  }

  function articleReducer(state, action) {
    const _state = structuredClone(state)
    const [siteId, key, value] = action
    _state[siteId] = _state[siteId] || {}
    _state[siteId][key] = value

    return _state
  }

  const [newsMap, dispatchNews] = useReducer(articleReducer, initialState)

  useEffect(() => {
    const siteConfigs = getSiteConfigRoutes();

    siteConfigs.map(async siteConfig => {
      const { siteId, sitePath } = siteConfig
      for await (const articlesResponse of listArticles(
        { news: true, featured: true },
        true,
        0,
        undefined,
        3,
        false,
        siteConfig)
      ) {
        const { articles, totalSize, nextLink, totalLoaded } = articlesResponse
        if (articles) {
          const prevArticles = newsMap?.[siteId]?.articles || []
          const newArticles = [...prevArticles, ...articles].map(a => ({ ...a, sitePath }))
          dispatchNews([siteId, 'articles', newArticles])
          dispatchNews([siteId, 'totalAvailable', totalSize])
          dispatchNews([siteId, 'nextToken', nextLink])
          if (totalLoaded) dispatchNews([siteId, 'totalLoaded', totalLoaded])
        }
      }
    })

  }, [])

  useEffect(() => {
    const newArts = []
    for (const key of Object.keys(newsMap)) {
      newArts.push(...newsMap[key].articles)
    }
    setAllArtices(newArts)
  }, [newsMap])

  return (
    <Grid
      container
      spacing={1}
      sx={{
        height: '100%'
      }}
    >

      <HeroCarousel
        editable={false}
        featured
        news
        published={true}
        articles={allArticles}
        loading={false}
        loadingMore={false}
        totalArticlesAvailable={0}
        moreAvailable={false}
        loadMoreArticles={() => { }}
        cycleDurationMs={cycleDurationMs}
      />

    </Grid>
  )
}